import { z } from "zod";

export const sendEmailAuthLink = {
  input: z.object({ email: z.string(), baseUrl: z.string() }),
  output: z.object({}),
};
